import React, {useContext, useEffect, useState} from "react";
import TrackVASContext from "../../TrackVASContext";
import {PageTitle} from "../../../_metronic/layout/core";
import {GenericTable} from "../generic/table/GenericTable";
import {defaultList} from "../generic/InitialStates";
import {ActionsColumnFormatter} from "../../column-formatters/ActionsColumnFormatter";
import {ENTITY_ID_ADVISORS} from "../generic/Constants";
import {HeaderColumnFormatter} from "../../column-formatters/HeaderColumnFormatter";
import {showConfirmDialog} from "../../generic-components/ConfirmDialog";
import {genericDelete} from "../generic/crud";
import {showToast, TOAST_SUCCESS} from "../../utils/toast/Toast";
import {AdvisorsAddEditDialog} from "./AdvisorsAddEditDialog";

export function AdvisorsPage() {
    const myData = useContext(TrackVASContext);
    const [reload, setReload] = useState(1);
    const [pageLoadComplete, setPageLoadComplete] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showModelId, setShowModelId] = useState(null);

    const profileBreadCrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    const ActiveStatusFormatter = (cellContent, row) => {
        return (
            <span className={`badge badge-light-${row.userActive ? 'success' : 'danger'}`}>
                {row.userActive ? 'Active' : 'Inactive'}
            </span>
        );
    };

    const columns = [
        {
            dataField: "id",
            text: "Id",
            hidden: true
        }, {
            dataField: "name",
            text: "Advisor Name",
            formatter: HeaderColumnFormatter,
            search: true
        },
        {
            dataField: "phone",
            text: "Phone",
            search: true
        },
        {
            dataField: "userActive",
            text: "Status",
            formatter: ActiveStatusFormatter,
            showInMobile: false,
        },
        {
            dataField: "action",
            text: "Actions",
            formatter: ActionsColumnFormatter,
            formatExtraData: {
                buttons:
                    [
                        {
                            name: "Edit",
                            color: "primary",
                            icon: "edit",
                            method: openEditDialog
                        },
                        {
                            name: "Delete",
                            color: "danger",
                            icon: "trash-alt",
                            method: openDeleteDialog
                        }
                    ],
            },
            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
        },
    ];

    function openEditDialog(row) {
        setShowModelId(row.id);
        setShowModal(true);
    }

    function reloadData() {
        setReload(reload + 1);
    }

    async function openDeleteDialog(row) {
        const result = await showConfirmDialog("Do you really want to delete the Service Advisor? You will be able to delete it only if it is not used anywhere.");
        if (result) {
            genericDelete(ENTITY_ID_ADVISORS, row.id).then(() => {
                showToast("Service Advisor is Deleted!", TOAST_SUCCESS);
                reloadData();
            }).catch(() => {
                }
            ).finally(() => {
                reloadData();
            });
        }
    }

    function addButtonClicked() {
        setShowModelId(null);
        setShowModal(true);
    }

    const handleClose = () => setShowModal(false);

    useEffect(() => {
        myData.setBaseData({
            toolBarButtons: [
                {
                    name: "ADD SERVICE ADVISOR",
                    color: "primary",
                    icon: "fa fa-plus",
                    onClick: addButtonClicked,
                },
            ],
        });

        setPageLoadComplete(true);

        return () => {
            myData.setBaseData({
                toolBarButtons: []
            });
        };
    }, []);

    return (
        <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Service Advisors</PageTitle>
            <div className="card card-body">
                {pageLoadComplete && (
                    <GenericTable
                        reload={reload}
                        defaultData={defaultList}
                        columns={columns}
                        entityId={ENTITY_ID_ADVISORS}
                    />
                )}
            </div>
            <AdvisorsAddEditDialog show={showModal} handleClose={handleClose} id={showModelId} onSave={reloadData}/>
        </>
    );
}
